import React from "react";
import { Box, Button, Typography } from "@mui/material";

const isTrustedPreviewUrl = (url) => {
  if (typeof url !== "string" || !url) return false;
  return url.startsWith("blob:") || url.startsWith("data:application/pdf");
};

const parseOtherIndex = (type) => {
  if (typeof type !== "string" || !type.startsWith("other-")) return -1;
  const value = Number(type.split("-")[1]);
  return Number.isInteger(value) && value >= 0 ? value : -1;
};

export default function ContractDocumentViewer({
  loading = false,
  type = "contract",
  onTypeChange,
  contractUrl = "",
  sepaUrl = "",
  additionalDocs = [],
  loadingText = "A carregar documento...",
  frameHeight = 520,
}) {
  const safeContractUrl = isTrustedPreviewUrl(contractUrl) ? contractUrl : "";
  const safeSepaUrl = isTrustedPreviewUrl(sepaUrl) ? sepaUrl : "";
  const safeAdditionalDocs = (additionalDocs || []).filter((item) => isTrustedPreviewUrl(item?.url));

  const selectedOtherIndex = parseOtherIndex(type);
  const selectedOtherUrl =
    selectedOtherIndex >= 0 && selectedOtherIndex < safeAdditionalDocs.length
      ? safeAdditionalDocs[selectedOtherIndex]?.url || ""
      : "";

  const currentUrl =
    type === "sepa"
      ? safeSepaUrl
      : type.startsWith("other-")
        ? selectedOtherUrl
        : safeContractUrl;

  const hasAnyDocs = Boolean(safeContractUrl || safeSepaUrl || safeAdditionalDocs.length > 0);

  return (
    <>
      {hasAnyDocs ? (
        <Box
          sx={{
            display: "flex",
            gap: 1,
            flexWrap: "wrap",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          {safeContractUrl ? (
            <Button
              size="small"
              variant={type === "contract" ? "contained" : "outlined"}
              onClick={() => onTypeChange?.("contract")}
              sx={{ maxWidth: 220 }}
            >
              <Box sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                Ver Contrato
              </Box>
            </Button>
          ) : null}
          {safeSepaUrl ? (
            <Button
              size="small"
              variant={type === "sepa" ? "contained" : "outlined"}
              onClick={() => onTypeChange?.("sepa")}
              sx={{ maxWidth: 220 }}
            >
              <Box sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                Ver SEPA
              </Box>
            </Button>
          ) : null}
          {safeAdditionalDocs.map((item, index) => (
            <Button
              key={item.id || `preview-other-doc-${index}`}
              size="small"
              variant={type === `other-${index}` ? "contained" : "outlined"}
              onClick={() => onTypeChange?.(`other-${index}`)}
              sx={{ maxWidth: 260 }}
            >
              <Box sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {item.label}
              </Box>
            </Button>
          ))}
        </Box>
      ) : null}

      <Box
        sx={{
          border: "1px solid #c8d1dc",
          borderRadius: 1,
          backgroundColor: "#fff",
          minHeight: 320,
          overflow: "hidden",
        }}
      >
        {loading ? (
          <Typography sx={{ p: 2 }} variant="body2" color="text.secondary">
            {loadingText}
          </Typography>
        ) : (
          <iframe
            title={type === "sepa" ? "SEPA Preview" : "Document Preview"}
            src={currentUrl}
            style={{ width: "100%", height: frameHeight, border: "none" }}
            referrerPolicy="no-referrer"
          />
        )}
      </Box>
    </>
  );
}

